export default __webpack_public_path__ + "static/media/bg-monitoring-0.cedc09f3.png";